import { normalizeMood } from './cms-mood';

type HashtagRow = {
  name: string;
  country: string | null;
};

// Country-scoped CMS tags plus the global (null-country) bucket. Other
// countries' tags stay out so Spain's Luxury does not leak into Portugal.
// Used for per-type section hashtag lists, not landing mood chips.
export const themesForCountry = (
  rows: readonly HashtagRow[],
  country: string
): string[] => {
  const names = new Set<string>();
  const needle = country.toLowerCase();
  for (const row of rows) {
    if (
      row.name &&
      (row.country === null || row.country.toLowerCase() === needle)
    ) {
      names.add(row.name);
    }
  }
  return [...names].sort((a, b) => a.localeCompare(b));
};

// Keep URL themes while the taxonomy is still loading (empty list).
// Canonicalize `#WINE` / `wine` onto the loaded chip spelling (`Wine`).
export const resolveAdvisorThemes = (
  selected: readonly string[],
  knownThemes: readonly string[]
): string[] => {
  if (selected.length === 0) return [];
  if (knownThemes.length === 0) return [...selected];
  const knownByNorm = new Map(
    knownThemes.map((theme) => [normalizeMood(theme), theme])
  );
  const out: string[] = [];
  const seen = new Set<string>();
  for (const theme of selected) {
    const known = knownByNorm.get(normalizeMood(theme));
    if (!known || seen.has(known)) continue;
    seen.add(known);
    out.push(known);
  }
  return out;
};
